let autocompleteB;
let autocompleteS;
let billingField;
let shippingField;
let billingpostalField;
let shippingpostalField;
let place;

function initAutocomplete() {    
    /**
     * Indirizzo di fatturazione
     */
    billingField = document.querySelector("#reg-findirizzo");    
    billingpostalField = document.querySelector("#reg-fcap");

    var opt = {
        requestedLanguage: _cc,
        fields: ["address_components", "geometry"],
        types: ["address"]
    }

    if (_restriction.length > 0) {
        opt.componentRestrictions= { country: _restriction };
    }

    autocompleteB = new google.maps.places.Autocomplete(billingField, opt);
    autocompleteB.addListener("place_changed", function () { fillInAddress('f'); });

    /**
     * Indirizzo di spedizione
     */
    shippingField = document.querySelector("#reg-sindirizzo");
    shippingpostalField = document.querySelector("#reg-scap");
    autocompleteS = new google.maps.places.Autocomplete(shippingField, opt);
    autocompleteS.addListener("place_changed", function () { fillInAddress('s'); });
}

function fillInAddress(t) {
    if (t === "f")
        place = autocompleteB.getPlace();
    else
        place = autocompleteS.getPlace();

    let address = "";
    let postcode = "";
    let citta = "";

    if (place) {
        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.
        // place.address_components are google.maps.GeocoderAddressComponent objects
        // which are documented at http://goo.gle/3l5i5Mr
        for (const component of place.address_components) {

            try {
                const componentType = component.types[0];
                switch (componentType) {
                    case "street_number": {
                        address = `${component.long_name} ${address}`;
                        break;
                    }
                    case "route": {
                        address = component.short_name + ', ' + address;
                        break;
                    }
                    case "postal_code": {
                        postcode = `${component.long_name}${postcode}`;
                        break;
                    }
                    case "postal_code_suffix": {
                        postcode = `${postcode}-${component.long_name}`;
                        break;
                    }
                    case "locality": {
                        citta = component.long_name;

                        if (_lcid === "1034") {
                            document.querySelector("#reg-" + t + "citta input").value = component.long_name;
                        }
                        else
                            document.querySelector("#reg-" + t + "citta").value = component.long_name;
                        break;
                    }
                    case "administrative_area_level_2": {
                        if (_lcid != 3079) {
                            document.querySelector("#reg-" + t + "provincia input").value = component.short_name;
                            $("#reg-" + t + "provincia").dxSelectBox("instance").option('value', component.short_name);

                            if (_lcid === "1034") {
                                $("#reg-" + t + "citta").dxSelectBox("instance").option('value', null);
                                var selectBoxDataSource = $("#reg-" + t + "citta").dxSelectBox("getDataSource");
                                selectBoxDataSource.pageIndex(0);
                                selectBoxDataSource.reload();
                                $("#reg-" + t + "citta").dxSelectBox("instance").option('value', citta);
                            }
                        }

                        break;
                    }
                    case "country":
                        document.querySelector("#reg-" + t + "nazione").value = component.short_name;
                        break;
                }
            } catch (e) {
                console.log(e);
            }
        }

        switch (t) {
            case "f":
                billingField.value = address;
                billingpostalField.value = postcode;
                break;
            case "s":
                shippingField.value = address;
                shippingpostalField.value = postcode;
                break;
        }
    }
}